import { SimulationDetailsRequestInterface } from '../../../../interfaces/request/simulator/simulation-details/simulation-details-request-interface';

export class SimulatorDetailsRequestModel implements SimulationDetailsRequestInterface {
  adOrigin?: string = '';
  agentCode?: string = '';
  email?: string = '';
  isPublicSite?: boolean = false;
  landing?: string = '';
  leadOrigin?: string = '';
  name?: string = '';
  peopleAges?: number[] = new Array<number>();
  phone?: string = '';
  phonePrefix?: string = '';
  productSimulationGroup?: string = '';
  productType?: string = '';
  taxNumber?: string = '';
  taxNumberCode?: string = '';
  totalPeople?: number = -1;
  pageGroup?: string = '';
  canSubscribe?: string = '';
  simulatedProduct?: any;
  salaryMassBetween?: any;
  crmId?: string = '';
  coupon?: string = '';
  phoneCode?: string = '';
  postalCodePrefix?: string = '';
  contractStartDate?: string = '';
}
